import { render } from "./CheckoutFormDetails.vue?vue&type=template&id=5570c033"
import script from "./CheckoutFormDetails.vue?vue&type=script&lang=js"
export * from "./CheckoutFormDetails.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__